import { Fragment, useEffect, useState, useRef } from "react";
import basvuruDetailLists from "../../services/basvuruDetailLists";
import basvuruAnaDurumList from "../../services/basvuruAnaDurumList"
import { Table, Card, Row, Col, Drawer, Modal, Spin, Input, Space, Button, Tooltip as TooltipAnd } from 'antd';
import { UnorderedListOutlined } from '@ant-design/icons'
import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from "recharts";
import history from "../../history";
import queryString from 'query-string';
import { DATE_FORMAT } from "../../constants";
import moment from "moment";
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
import ReactExport from "react-export-excel";
import ExcelExport from '../ExcelExport';
import { FileExcelOutlined, OrderedListOutlined } from "@ant-design/icons";
import BasvuruAnaOzetFilterRow from "../BasvuruAnaOzetFilterRow/BasvuruAnaOzetFilterRow";
import useColumns from "../../hooks/useColumns";
import basvuruStateZamanlariList from "../../services/basvuruStateZamanlariLists";
import getParametreDeger from "../../services/getParametreDeger";

const parsed = queryString.parse(history.location.search);

const BasvuruAnaOzetList = () => {
  const [dates, setDates] = useState([moment(), moment()]);
  const [expandedBasvuruAnaOzet, setExpandedBasvuruAnaOzet] = useState([]);
  const [queryDates, setQueryDates] = useState([undefined, undefined]);
  const [visible, setVisible] = useState(false);
  let [basvuruDetails, setBasvuruDetails] = useState([]);
  const [spining, setSpining] = useState(false);
  let [searchText, setSearchText] = useState("");
  let [searchInput, setsearchInput] = useState("");
  let [searchedColumn, setsearchedColumn] = useState("");
  const [basvuruStateList, setBasvuruStateList] = useState([]);
  const [filtredBasvuruAnOzet, setFiltredBasvuruAnaOzet] = useState([]);
  const [basvuruAnaOzet, setBasvuruAnaOzet] = useState([]);
  const [filterBasvuruAnaOzet, setFilterBasvuruAnaOzet] = useState([]);
  const [basvuruColumns, setBasvuruColumns] = useState([]);
  const [totalCountBasvuruAna, setTotalCountBasvuruAna] = useState(0);
  const { basvuruDetailColumns, basvuruSurecGecmisColumns } = useColumns();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isCompanyIlOzelIdare, setIsCompanyIlOzelIdare] = useState(false);

  const belgeGrubuId = parsed.belgeGrubuId.split(',').map(item => { return parseInt(item) });


  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            searchInput = node;
          }}
          placeholder={`Ara `}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            // icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Ara
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Sıfırla
          </Button>
          {/* <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
                searchText= selectedKeys[0];
                searchedColumn= dataIndex;
              }}
          >
            Filtre
          </Button> */}
        </Space>
      </div>
    ),
   
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        text
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    searchText = selectedKeys[0];
    searchedColumn = dataIndex;
  };

  const handleReset = clearFilters => {
    clearFilters();
    searchText = '';
  };


  const showModal = () => {

    setIsModalVisible(true);
  };


  let generalBasvuruColumns = [
    {
      title: 'Ana Başvuru No',
      dataIndex: 'objectid',
      key: 'objectid',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.objectid - b.objectid,
      ...getColumnSearchProps('objectid'),
    },
    {
      title: 'Belge Türü',
      dataIndex: 'belge_turu_adi',
      key: 'belge_turu_adi',
      sorter: (a, b) => { return a.belge_turu_adi.localeCompare(b.belge_turu_adi) },
      ...getColumnSearchProps('belge_turu_adi'),
    },
    {
      title: 'İlçe',
      dataIndex: 'ilce_adi',
      key: 'ilce_adi',
      sorter: (a, b) => { return a.ilce_adi.localeCompare(b.ilce_adi) },
      ...getColumnSearchProps('ilce_adi'),
    },
    {
      title: 'Mahalle',
      dataIndex: 'geomahalle_adi',
      key: 'geomahalle_adi',
      sorter: (a, b) => { return a.geomahalle_adi.localeCompare(b.geomahalle_adi) },
      ...getColumnSearchProps('geomahalle_adi'),
    },
    {
      title: 'Ada/Parsel',
      dataIndex: 'adaparsel',
      key: 'adaparsel',
      sorter: (a, b) => { return a.adaparsel.localeCompare(b.adaparsel) },
      ...getColumnSearchProps('adaparsel'),
    },
    {
      title: 'Ana Başvuru Durumu',
      dataIndex: 'basvuru_ana_durumu_adi',
      key: 'basvuru_ana_durumu_adi',
      sorter: (a, b) => { return a.basvuru_ana_durumu_adi.localeCompare(b.basvuru_ana_durumu_adi) },
      ...getColumnSearchProps('basvuru_ana_durumu_adi'),
    }
  ]

  useEffect(() => {
    getParametreDeger('EBELGE.ORTAK.COMPANY_TYPE').then(res => {
      setIsCompanyIlOzelIdare(res.data.result == 1);
    });
    basvuruAnaDurumList().then(res => {
      setBasvuruAnaOzet(res.data.result.filter(item => item.belge_turu_id == belgeGrubuId));
      setFilterBasvuruAnaOzet(res.data.result.filter(item => item.belge_turu_id == belgeGrubuId));
      dynamicColumnSet(res.data.result.filter(item => item.belge_turu_id == belgeGrubuId));
      setTotalCountBasvuruAna(res.data.result.length);
    }

    );
    setQueryDates(dates);
  }, []);


  const openModalBasvuruStateList = (basvuruId, altSurecTipiId) => {

    let filterModel = {};

    if (basvuruId !== undefined && basvuruId != null) {
      filterModel.basvuruId = basvuruId;
    }
    if (altSurecTipiId !== undefined && altSurecTipiId != null) {
      filterModel.altSurecTipiId = altSurecTipiId;
    }
    setSpining(true);
    basvuruStateZamanlariList(filterModel).then(res => { setSpining(false); console.log("Başarılı"); setBasvuruStateList(res.data.result); showModal(); }).catch(ex => setSpining(false));

  };



  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };


  const dynamicColumnSet = (basvuruAnaOzet) => {
    let firstRow = basvuruAnaOzet[0];
    for (const [key, value] of Object.entries(firstRow)) {
      console.log(`${key}: ${value}`);

      if (!(generalBasvuruColumns.filter(items => items.key == key).length > 0)) {
        if (!key.includes("id") && key !== "HarcToplami" && key !== "BelgeGecenSure" && key !== "BelgeKapanisZamani" && key !== "BelgeBasvuruZamani") {
          generalBasvuruColumns.push({
            title: key,
            dataIndex: key,
            key: key,
            sorter: (a, b) => {
              a[key] = a[key] || '';
              b[key] = b[key] || '';
              return a[key].localeCompare(b[key])
            },
            ...getColumnSearchProps(key),
          })
        }
      }
    }
  
    setBasvuruColumns(generalBasvuruColumns);
  }

  const getReportByFilter = (belgeTuruId, basvuruAnaDurumuId, basvuruNo, ilceId, geomahalleId, adaParsel) => {

    let filterModel = {};

    if (belgeTuruId !== undefined && belgeTuruId != null) {
      filterModel.belgeTuruId = [];
      filterModel.belgeTuruId.push(belgeTuruId);
    }
    if (basvuruAnaDurumuId !== undefined && basvuruAnaDurumuId != null) {
      filterModel.basvuruAnaDurumuId = basvuruAnaDurumuId;
    }
    if (basvuruNo !== undefined && basvuruNo != null) {
      filterModel.basvuruNo = basvuruNo;
    }
    if (ilceId !== undefined && ilceId != null) {
      filterModel.ilceId = ilceId;
    }
    if (geomahalleId !== undefined && geomahalleId != null) {
      filterModel.geomahalleId = geomahalleId;
    }
    if (adaParsel !== undefined && adaParsel != null) {
      filterModel.adaParsel = adaParsel;
    }
    setSpining(true);
    basvuruAnaDurumList(filterModel).then(res => { setFilterBasvuruAnaOzet(res.data.result); setTotalCountBasvuruAna(res.data.result); setSpining(false); }).catch(ex => { setSpining(false) });

    // dynamicColumnSet(filterBasvuruAnaOzet);
  }
 
  let opKeyTitles = basvuruColumns.map((item) => { return { key: item.key, title: item.title } });
  const basvuruDetailKeyTitles = basvuruDetailColumns.map(items => { return { key: items.key, title: items.title } });

  const getBasvuruColumns = () => {
    if (!isCompanyIlOzelIdare) return basvuruColumns?.filter(s => s.key != 'ilce_adi');
    return basvuruColumns;
  }
  return <Spin tip={"Veriler Yükleniyor"} spinning={spining} > <Card
    style={{ margin: "20px" }}
    title={<h3 style={{ fontWeight: "bolder", color: "white" }}>Ruhsat Ana Başvuru Raporları</h3>}
    className="ant-card-head-title-large"
  >
    <Row>
      <BasvuruAnaOzetFilterRow onSubmit={getReportByFilter} getIsCompanyIlOzelIdare={() => isCompanyIlOzelIdare} />


    </Row>
    <Row gutter={24}>
      <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24}>
        <Table bordered rowKey={"objectid"} dataSource={filterBasvuruAnaOzet}
          title={() => <div style={{ display: "flex", justifyContent: "space-between" }}><h5 style={{ fontWeight: "bolder" }}>{''}</h5>
            <ExcelExport
              fileName={'Ruhsat Başvuruları ' + " - " + queryDates[0]?.format(DATE_FORMAT) + "-" + queryDates[1]?.format(DATE_FORMAT)}
              downloadButton={<Button type="link" icon={<FileExcelOutlined style={{ color: "green" }} />} />}
              sheets={[{ data: filterBasvuruAnaOzet, name: 'Test', keyTitles: opKeyTitles }]} />
          </div>}
          columns={getBasvuruColumns()}
          onChange={
            (pagination, filters, sorter, extra) => {
              if (extra.currentDataSource.length < filterBasvuruAnaOzet.length) {
                setTotalCountBasvuruAna(extra.currentDataSource.length);
              }
              else {
                setFiltredBasvuruAnaOzet(filterBasvuruAnaOzet);
                setTotalCountBasvuruAna(filterBasvuruAnaOzet.length);
              }
            }
          }
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
            total: totalCountBasvuruAna && totalCountBasvuruAna,
            showTotal: (total) => <div>{"Toplam: " + total}</div>
          }}
        
        />
      </Col>
      <Modal title="Başvuru Geçmişi" centered visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
        <Table rowKey={"stateId"} bordered dataSource={basvuruStateList} columns={basvuruSurecGecmisColumns}
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
            total: basvuruStateList && basvuruStateList.length,
            showTotal: (total) => <div>{"Toplam: " + total}</div>
          }}
        />
      </Modal>
    </Row>
    {
    }
  </Card>
  </Spin>
}
export default BasvuruAnaOzetList;